import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit'

import { IScrollPosition } from '../hooks/useScrollPosition'

// eslint-disable-next-line import/no-cycle
import { RootState } from './types'

const initialState: Record<string, IScrollPosition> = {}

const slice = createSlice({
  name: 'scrollPositions',
  initialState,
  reducers: {
    set(state, action: PayloadAction<{ id: string } & IScrollPosition>) {
      const { id, ...scrollPosition } = action.payload
      state[id] = scrollPosition
    },
  },
})

// Actions
export const { set: setScrollPosition } = slice.actions

// Selectors
const selectScrollPosition = (state: RootState) => state.scrollPositions

export const defaultScrollPosition: IScrollPosition = { x: 0, y: 0 }

export const makeSelectScrollPosition = (id: string) =>
  createSelector(
    selectScrollPosition,
    (scrollPositions) => scrollPositions[id] ?? defaultScrollPosition
  )

// Reduce
export default slice.reducer
